// components/PrivateRoute.tsx
import { Navigate, useLocation } from "react-router";
import { useAuth } from "../hooks/useAuth";
import { useUnitRedirect } from "../hooks/useUnitRedirect";

export default function PrivateRoute({
  children,
}: {
  children: React.ReactNode;
}) {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  useUnitRedirect(user);

  if (!isAuthenticated) {
    return <Navigate to="/giris-yap" state={{ from: location }} replace />;
  }

  return children;
}
